import { useState } from 'react';

import { Box, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

import PDFSignatureViewer from '../../../components/PDFSignature/PDFSignatureViewer';

interface StepThreeProps {
  setPdfFile: (file: File | null, url: string | null) => void;
  signees: Array<{
    name: string;
    email: string;
    signeeType: string;
    color: string;
    level: number;
    fields: Array<{
      type: string;
      label: string;
    }>;
  }>;
  initialPdf?: string | null;
  contractDetails?: {
    levels: number;
    yearToRetain: number;
    creatorRole: string;
    contractName: string;
    formData?: any[];
    levelData?: Array<{
      level: number;
      signees: Array<{
        name: string;
        email: string;
        signeeType: string;
        color: string;
        level: number;
        fields: Array<{
          type: string;
          label: string;
        }>;
      }>;
    }>;
  };
  uuid?: string;
  folderId?: string | null;
}

const StepThree: React.FC<StepThreeProps> = ({
  setPdfFile,
  signees,
  initialPdf,
  contractDetails,
  uuid,
  folderId,
}) => {
  const { companyId, username } = useSelector((state: RootState) => state.auth);
  const [selectedPdf, setSelectedPdf] = useState<string | null>(
    initialPdf || null
  );

  // Get signees from contractDetails.levelData
  const signeesWithTypes =
    contractDetails?.levelData?.flatMap((level) => level.signees) || signees;

  const handlePdfUpload = async (file: File) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      if (companyId) formData.append('companyId', companyId);
      if (username) formData.append('username', username);

      const response = await fetch('/api/upload', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        setSelectedPdf(data.url);
        setPdfFile(file, data.url);
      }
    } catch (error) {
      console.error('Error uploading PDF:', error);
    }
  };

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setSelectedPdf(url);
      handlePdfUpload(file);
    }
  };

  const handlePdfSave = (pdfBytes: Uint8Array) => {
    const blob = new Blob([pdfBytes as unknown as BlobPart], {
      type: 'application/pdf',
    });
    const url = URL.createObjectURL(blob);
    setSelectedPdf(url);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 3 }}>
        <input
          type="file"
          accept=".pdf"
          onChange={handleFileSelect}
          style={{ display: 'none' }}
          id="pdf-upload"
        />
        <label htmlFor="pdf-upload">
          <Button
            variant="contained"
            component="span"
            sx={{
              borderRadius: 2,

              py: 1.2,
              px: 3,
            }}
          >
            Upload contract pdf
          </Button>
        </label>
      </Box>
      {selectedPdf && (
        <PDFSignatureViewer
          pdfFile={selectedPdf}
          currentUserEmail={username || ''}
          onSave={handlePdfSave}
          signees={signeesWithTypes}
          contractDetails={contractDetails}
          uuid={uuid}
          folderId={folderId}
        />
      )}
    </Box>
  );
};

export default StepThree;
// pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs`;
